import { render, staticRenderFns } from "./EmpreinteEconomique.vue?vue&type=template&id=4d74b52e&"
import script from "./EmpreinteEconomique.vue?vue&type=script&lang=js&"
export * from "./EmpreinteEconomique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports